import { type GifAttachment } from "@fitness-app/data-models/entities/Chat";

export interface GifDisplayBounds {
  maxWidth: number;
  maxHeight: number;
}

export interface GifDisplaySize {
  width: number;
  height: number;
}

/**
 * Fits a GIF into a bubble: as wide as the bounds allow for landscape, capped by height for
 * portrait, and never upscaled past the source. Falls back to a square when the provider sent no
 * dimensions, so the bubble still reserves space before the animation loads.
 */
export const getGifDisplaySize = (
  gif: Pick<GifAttachment, "width" | "height">,
  { maxWidth, maxHeight }: GifDisplayBounds,
): GifDisplaySize => {
  const sourceWidth = gif.width > 0 ? gif.width : maxWidth;
  const sourceHeight = gif.height > 0 ? gif.height : sourceWidth;
  const ratio = sourceWidth / sourceHeight;

  let width = Math.min(maxWidth, sourceWidth);
  let height = width / ratio;

  if (height > maxHeight) {
    height = maxHeight;
    width = height * ratio;
  }

  return { width: Math.round(width), height: Math.round(height) };
};
